import { render, staticRenderFns } from "./StatusBar.vue?vue&type=template&id=6f766fe3&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "StatusBar.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/icons/StatusBar.vue
// module id = 2332
// module chunks = 1